import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Transport } from 'src/app/core/_models/transport';

@Component({
  selector: 'app-dialog-composition',
  templateUrl: './dialog-composition.component.html',
  styleUrls: ['./dialog-composition.component.scss']
})
export class DialogCompositionComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<DialogCompositionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.selectTransportChange(this.data?.transportId || this.data?.transports[0].resourceId);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  selectTransportChange(value: string) {
    let t: Transport = this.data?.transports?.find((t: Transport) => t.resourceId == value);
    if (t) {
      this.data.familyDisplayName = t?.familyDisplayName;
      this.data.transportDisplayName = t?.displayName;
      this.data.transportId = t?.resourceId;
    }
  }
}
